import React, { useState, useEffect } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase/config';
import { useLanguage } from '../context/LanguageContext';
import { DEFAULT_POLICIES } from '../constants/defaultPolicies';

export const POLICY_TABS = [
    { id: 'return', label: 'Return & Exchange', labelAr: 'الاستبدال والاسترجاع' },
    { id: 'buying', label: 'Buying & Shipping', labelAr: 'الشراء والشحن' },
    { id: 'terms', label: 'Terms & Conditions', labelAr: 'الشروط والأحكام' }
];

const PoliciesContent = ({ activeTab: externalTab, onTabChange }) => {
    const [internalTab, setInternalTab] = useState(externalTab || 'return');
    const { lang } = useLanguage();
    const isAr = lang === 'ar';
    const [customPolicies, setCustomPolicies] = useState(null);

    useEffect(() => {
        if (externalTab) {
            setInternalTab(externalTab);
        }
    }, [externalTab]);

    useEffect(() => {
        if (!db) return;
        const policyRef = doc(db, 'storeSettings', 'policies');
        const unsubscribe = onSnapshot(policyRef, (docSnap) => {
            if (docSnap.exists()) {
                setCustomPolicies(docSnap.data());
            }
        });
        return () => unsubscribe();
    }, []);

    const currentTab = internalTab;
    const currentKey = `${currentTab}_${isAr ? 'ar' : 'en'}`;
    const policyHtml = customPolicies?.[currentKey] || DEFAULT_POLICIES[currentKey];

    const handleTabClick = (tabId) => {
        setInternalTab(tabId);
        if (onTabChange) onTabChange(tabId);
    };

    return (
        <div className="w-full">
            {/* Tabs Navigation */}
            <div className="flex flex-wrap justify-center gap-2 border-b border-gray-200 pb-4 mb-6">
                {POLICY_TABS.map((tab) => {
                    const isActive = currentTab === tab.id;
                    return (
                        <button
                            key={tab.id}
                            type="button"
                            onClick={() => handleTabClick(tab.id)}
                            className={`px-4 py-2.5 text-xs sm:text-sm font-serif tracking-wider uppercase rounded-sm transition-all ${
                                isActive
                                    ? 'bg-[#b08d57] text-white font-semibold shadow-sm'
                                    : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                            }`}
                        >
                            {isAr ? tab.labelAr : tab.label}
                        </button>
                    );
                })}
            </div>

            {/* Policy Content Body */}
            <div
                dir={isAr ? 'rtl' : 'ltr'}
                className="space-y-4 text-start text-gray-700 text-sm sm:text-base leading-relaxed"
                dangerouslySetInnerHTML={{ __html: policyHtml }}
            />
        </div>
    );
};

export default PoliciesContent;
